<div class="flex flex-column justify-content-evenly">
    <div class="w-10 m-auto">
        <h3 class="text-center">Destaca tu perfil</h3>
        <p class="text-center">Con esta opción, podrás crear un destaque con el que llamarás la atención de los usuarios. Ten en cuenta que este aviso será visible durante 24 horas</p>
    </div>
    <div class="w-11 md:w-7 m-auto">
        <p-steps [model]="steps" [readonly]="true" [activeIndex]="activeStep" (activeIndexChange)="changeStep($event)"></p-steps>
    </div>
    <div *ngIf="person">
        <div *ngIf="activeStep === 0" class="w-10 m-auto py-2">
            <h3>Elige una de tus imágenes para utilizar en la publicación</h3>
            <div class="w-full m-auto flex flex-row flex-wrap gap-3 justify-content-center">
                <div *ngFor="let image of person.mediaContent; let index = index" key="index" class="flex flex-column w-5 lg:w-2 gap-1">
                    <img *ngIf="image.type !== '.mp4'" [src]="thumbnailLocation + image.fileName" class="w-full" />
                    <p-button *ngIf="image.type !== '.mp4'" label="Seleccionar imagen" 
                        icon="{{index === selectedIndex ? 'pi pi-check' : ''}}" styleClass="w-full" [disabled]="isInUse(index)"
                        (onClick)="selectImage(index)"></p-button>
                </div>
            </div>
        </div>
        <div *ngIf="activeStep === 1" class="w-10 m-auto py-2">
            <h3>Escoge una frase para llamar la atención</h3>
            <div class="w-full m-auto flex flex-row flex-wrap gap-3 justify-content-center">
                <p-button *ngFor="let phrase of activityPhrases" label="{{ phrase }}" (onClick)="selectPhrase(phrase)"></p-button>
            </div>
        </div>
        <div *ngIf="activeStep === 2" class="w-10 m-auto py-2">
            <h3>Revisar el contenido a destacar</h3>
            <div class="relative w-10 md:w-3 justify-content-center shadow-4 m-auto z-2">
                <img [src]="thumbnailLocation + person.mediaContent![selectedIndex].fileName" class="w-full" />
                <div class="absolute z-3 bottom-0 activity-phrase w-full">
                    <p class="quote">"{{ selectedPhrase }}"</p>
                </div>
            </div>
            <div class="flex flex-row gap-3 my-2 m-auto w-10 justify-content-center py-2">
                <p-button label="Cancelar" class="grey" (onClick)="clear()"></p-button>
                <p-button label="Publicar" (onClick)="saveActivity()" [loading]="loading"></p-button>
            </div>
        </div>
    </div>
</div>